import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { pascalize } from 'humps';

import { withTranslation } from '../../i18n';
import Input from '../../components/Forms/Input';

class LanguageLevelSelect extends PureComponent {
  render() {
    const { language, label, t } = this.props;

    return (
      <Field name={`languageLevel${pascalize(language)}`} component={Input} as="select" label={label}>
        <option value="beginner">{t('languageLevel.beginner')}</option>
        <option value="basic">{t('languageLevel.basic')}</option>
        <option value="intermediate">{t('languageLevel.intermediate')}</option>
        <option value="advanced">{t('languageLevel.advanced')}</option>
        <option value="native">{t('languageLevel.native')}</option>
      </Field>
    );
  }
}

LanguageLevelSelect.propTypes = {
  label: PropTypes.string.isRequired,
};

export default withTranslation('common')(LanguageLevelSelect);
